import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import InputCustom from "../components/inputCustom.react";
import Modal from "../components/modal.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class GalleryTemplateField extends Component {
  removeGallery = () => {
    const {
      gallery,
      actions,
      notificationSystem,
      afterServerActionSuccess,
      uid
    } = this.props;
    actions.removeGallery(gallery.get("uid")).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        afterServerActionSuccess(uid);
      }
    });
    actions.setIsRemoveGalleryModalVisible(false);
  };

  openRemoveGalleryModal = () => {
    const { actions, gallery } = this.props;
    actions.setIsRemoveGalleryModalVisible(gallery.get("uid"));
  };

  closeRemoveGalleryModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveGalleryModalVisible(false);
  };

  render() {
    const { gallery, actions, isRemoveModalVisible } = this.props;
    const inputCustomProps = {
      feature: "galleries",
      actions: actions,
      entity: gallery,
      uid: gallery.get("uid"),
      placeholder: ""
    };

    return (
      <div className="col-xs-12">
        <div className="box-wrapper">
          <div className="title">
            <div className="row middle-xs">
              <div className="col-xs-6">{gallery.get("name")}</div>
              <div className="col-xs-6">
                <button className="error" onClick={this.openRemoveGalleryModal}>
                  usuń galerię
                </button>
              </div>
            </div>
          </div>
          <div className="content-wrapper">
            <div className="row middle-xs">
              <label className="col-xs-4">Nazwa galerii</label>
              <div className="col-xs-8">
                <InputCustom {...inputCustomProps} field={["name"]} />
              </div>
            </div>
            <div className="row middle-xs">
              <label className="col-xs-4">Placeholder</label>
              <div className="col-xs-8">
                <InputCustom {...inputCustomProps} field={["placeholder"]} />
              </div>
            </div>
          </div>
        </div>
        {isRemoveModalVisible === gallery.get("uid") && (
          <Modal
            closeModalAction={this.closeRemoveGalleryModal}
            enterAction={this.removeGallery}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <p>Czy napewno usunąć?</p>
              <div className="col-xs-12">
                <button className="error" onClick={this.removeGallery}>
                  Usuń
                </button>
                <button className="info" onClick={this.closeRemoveGalleryModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/galleries/galleryTemplateField.react.js